import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import React from "react";
import BoltIcon from "./RequestFlags/BoltIcon";
import CopyIcon from "./RequestFlags/CopyIcon";
import ModifiedIcon from "./TestSeriesFlags/ModifiedIcon";
import PendingActionsIcon from "./RequestFlags/PendingActionsIcon";

export type TestRequestFlag = TestRequestRaw.Schemas.TestRequestFlag;
export type TestSeriesFlag = "MODIFIED";
type Flag = TestRequestFlag | TestSeriesFlag;

export const FLAG_ICONS_MAPPING: {
  [F in Flag]: React.ReactElement;
} = {
  DEADLINE_MAY_NOT_BE_MET: <BoltIcon />,
  DUPLICATED: <CopyIcon />,
  HISTORICAL: <AccountBalanceIcon />,
  OVERDUE: <ReportProblemOutlinedIcon />,
  SPECIFICATION_NEEDED: <></>,
  WAITING_FOR_MATERIAL: <PendingActionsIcon />,
  MODIFIED: <ModifiedIcon />,
};

export const FLAG_TOOLTIPS_MAPPING: {
  [F in Flag]: string;
} = {
  DEADLINE_MAY_NOT_BE_MET: "Conflict between Deadline Date and Estimated Finishing Date",
  DUPLICATED: "Duplicated Test Request",
  HISTORICAL: "Historical Test Request",
  OVERDUE: "Estimated Finishing Date overdue",
  SPECIFICATION_NEEDED: "",
  WAITING_FOR_MATERIAL: "Waiting for Material (Substrates/Products)",
  MODIFIED: "Predefined actions, conditions or properties of the original definition of the test series were modified.",
};

export const FLAGS_ORDERED = [
  "DEADLINE_MAY_NOT_BE_MET",
  "OVERDUE",
  "WAITING_FOR_MATERIAL",
  "DUPLICATED",
  "HISTORICAL",
  "MODIFIED",
] as const;

export default Flag;
